// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_SFaVQ {
  position: relative;
  width : 80vw;
  height : 80vh;
}
.dialogBody_Nz8ez {
  width : 100% !important;
  position : relative !important;
  overflow: hidden !important;
}
.dialog_SFaVQ > div {
  position : absolute !important;
  top : 0 !important;
  left : 0 !important;
  right : 0 !important;
  bottom : 0 !important;
}

.pane_hro0j {

  display : grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas: 
    "msg msg msg"
    "tab tab tab";
  row-gap: 8px;
  column-gap: 8px;
  padding : 8px;
  position : absolute;
  top : 0;
  right: 0;
  left : 0;
  bottom : 0;
  padding : 8px;
}

.msg_oW0xJ {
  grid-area : msg;
}

.tab_lFTUh {
  grid-area : tab;
  overflow: hidden !important;
}

.details__18Yo {
  grid-area: details;
  overflow: hidden !important;
}

.details__18Yo > pre {
  overflow: auto;
  height: 100%;
}

.noItems_PYgy2 {
  padding : 24px;
}

.itemList_De3RS {
  max-height : 100%;
  min-width : 200px;
}

.detailsText__eZAx {
  background-color: transparent;
  border : none;
  padding : 8px;
}`, "",{"version":3,"sources":["webpack://./src/screens/main/ImportResults.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,4BAA4B;EAC5B;;iBAEe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,aAAa;AACf","sourcesContent":[".dialog {\n  position: relative;\n  width : 80vw;\n  height : 80vh;\n}\n.dialogBody {\n  width : 100% !important;\n  position : relative !important;\n  overflow: hidden !important;\n}\n.dialog > div {\n  position : absolute !important;\n  top : 0 !important;\n  left : 0 !important;\n  right : 0 !important;\n  bottom : 0 !important;\n}\n\n.pane {\n\n  display : grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: auto 1fr;\n  grid-template-areas: \n    \"msg msg msg\"\n    \"tab tab tab\";\n  row-gap: 8px;\n  column-gap: 8px;\n  padding : 8px;\n  position : absolute;\n  top : 0;\n  right: 0;\n  left : 0;\n  bottom : 0;\n  padding : 8px;\n}\n\n.msg {\n  grid-area : msg;\n}\n\n.tab {\n  grid-area : tab;\n  overflow: hidden !important;\n}\n\n.details {\n  grid-area: details;\n  overflow: hidden !important;\n}\n\n.details > pre {\n  overflow: auto;\n  height: 100%;\n}\n\n.noItems {\n  padding : 24px;\n}\n\n.itemList {\n  max-height : 100%;\n  min-width : 200px;\n}\n\n.detailsText {\n  background-color: transparent;\n  border : none;\n  padding : 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_SFaVQ`,
	"dialogBody": `dialogBody_Nz8ez`,
	"pane": `pane_hro0j`,
	"msg": `msg_oW0xJ`,
	"tab": `tab_lFTUh`,
	"details": `details__18Yo`,
	"noItems": `noItems_PYgy2`,
	"itemList": `itemList_De3RS`,
	"detailsText": `detailsText__eZAx`
};
export default ___CSS_LOADER_EXPORT___;
